import React from "react"
import Button from "../common/Button.jsx"

/**
 * @param {{
 *   showImportLodgeManifestWorkflow?: boolean,
 *   onImportLodgeManifestClick?: () => void,
 * }} props
 */
export default function ManifestsHeader({
    showImportLodgeManifestWorkflow = true,
    onImportLodgeManifestClick = () => {},
}) {
    return (
        <div
            className={
                "d-flex flex-column flex-sm-row justify-content-between " +
                "align-items-start align-items-sm-center mb-4"
            }
        >
            <h1 className="fs-2 fw-bold text-dark">Manifests</h1>
            <div className="d-flex gap-2 mt-3 mt-sm-0">
                {showImportLodgeManifestWorkflow ? (
                    <Button
                        variant="custom"
                        size="sm"
                        className="v2-not-implemented-btn"
                        onClick={onImportLodgeManifestClick}
                        title="Not implemented yet"
                    >
                        Import Lodge Manifest
                    </Button>
                ) : null}
            </div>
        </div>
    )
}

